import ShopMenuItemCarousels from "./ShopMenuItemCarousels";

export default ShopMenuItemCarousels;
